import { createContext, useMemo, useState } from 'react';

import type { JSX, ReactNode } from 'react';

import { EMPTY_ARRAY, NULL_FUNCTION } from '@e-socna/empty';

import type { PrinterFormValues } from '../../../../forms/Printer';

import { usePrinterInput } from '../../hooks/usePrinterInput.hook';

import type { ResolverContextData } from './types/resolver-context.type';

const DocumentResolverContext = createContext<ResolverContextData>({
  contentToPrint: EMPTY_ARRAY,
  printerSettings: undefined,
  setPrinterSettings: NULL_FUNCTION,
});

interface Props {
  readonly children: ReactNode;
}

const DocumentResolverContextProvider = ({
  children,
}: Readonly<Props>): JSX.Element => {
  const contentToPrint = usePrinterInput();
  const [printerSettings, setPrinterSettings] = useState<
    PrinterFormValues | undefined
  >();

  const value = useMemo<ResolverContextData>(
    () => ({
      contentToPrint,
      printerSettings,
      setPrinterSettings,
    }),
    [contentToPrint, printerSettings],
  );

  return (
    <DocumentResolverContext.Provider value={value}>
      {children}
    </DocumentResolverContext.Provider>
  );
};

export { DocumentResolverContext, DocumentResolverContextProvider };
